import type { AvaliacaoQueda, NivelQueda } from '../../dominio/tabletop'

const ROTULO_NIVEL: Readonly<Record<NivelQueda, string>> = {
  baixo: 'Nível baixo',
  moderado: 'Nível moderado',
  grave: 'Nível grave',
  critico: 'Nível crítico',
}

const virgula = (valor: number, casas = 1) => valor.toFixed(casas).replace('.', ',')

export interface PropsBannerQuedaSolta {
  avaliacao: AvaliacaoQueda
  aoRepetir: () => void
  /** Fecha o resultado e deixa o trabalhador onde ele caiu. */
  aoConcluir: () => void
  /** Quando informado, o instrutor ajusta o limite de força no corpo (kN) usado no nível. */
  aoMudarLimiteKN?: (limiteKN: number) => void
}

/** Resultado da queda de um trabalhador solto no ar: o nível de gravidade, os números e o que fazer em seguida. */
export function BannerQuedaSolta({ avaliacao, aoRepetir, aoConcluir, aoMudarLimiteKN }: PropsBannerQuedaSolta) {
  return (
    <div
      className={`tt-banner-posicionamento tt-banner-queda tt-banner-queda--${avaliacao.nivel}`}
      role="status"
      aria-live="polite"
    >
      <div className="tt-banner-queda__texto">
        <strong>
          {ROTULO_NIVEL[avaliacao.nivel]} · {avaliacao.titulo}
        </strong>
        <span>{avaliacao.detalhe}</span>
        <span className="tt-banner-queda__dados">
          <span>Altura: {virgula(avaliacao.alturaM)} m</span>
          {avaliacao.velocidadeImpactoKmh !== null && <span>Impacto: {Math.round(avaliacao.velocidadeImpactoKmh)} km/h</span>}
          {avaliacao.fatorDeQueda !== null && <span>Fator de queda: {virgula(avaliacao.fatorDeQueda, 2)}</span>}
          {avaliacao.forcaPicoKN !== null && <span>Pico: {virgula(avaliacao.forcaPicoKN)} kN</span>}
        </span>
      </div>
      {aoMudarLimiteKN && avaliacao.preso && (
        <label className="tt-banner-queda__limite">
          Limite no corpo (kN)
          <input
            type="number"
            min={1}
            max={20}
            step={0.5}
            value={avaliacao.limiteForcaKN}
            onChange={(e) => {
              const v = Number(e.target.value)
              if (Number.isFinite(v) && v > 0) aoMudarLimiteKN(v)
            }}
          />
        </label>
      )}
      <div className="tt-banner-queda__acoes">
        <button type="button" className="btn-acao-cad btn-acao-cad--destaque" onClick={aoRepetir}>
          Repetir queda
        </button>
        <button type="button" className="btn-acao-cad btn-acao-cad--secundario" onClick={aoConcluir}>
          Concluir (deixar onde caiu)
        </button>
      </div>
    </div>
  )
}
